import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const planApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'planApi',
  tagTypes: ['PlanList', 'QuotationList', 'PolicyList'],
  endpoints: () => ({})
})

export default planApi
